module.exports = __webpack_public_path__ + "img/happyquest.ac2aae55.png";